import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type MenuFile = {
  menu_file_id?: number; // 메뉴 파일 idx
  menu_id?: number; // 메뉴 idx
  file_name?: string; // 파일명 idx
  file_url?: string; // 파일 경로
  type?: string; // 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] MenuFile
   * --
   */
  getMenuFiles: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_MENU_FILE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] MenuFile
   * --
   */
  getMenuFile: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_MENU_FILE, {
        menu_file_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] MenuFile
   * --
   */
  createMenuFile: async (body: MenuFile) => {
    try {
      const res = await $http.post(APIConstant.CREATE_MENU_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] MenuFile
   * --
   */
  updateMenuFile: async (body: MenuFile) => {
    try {
      const { menu_file_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_MENU_FILE, {
        menu_file_id: menu_file_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] MenuFile
   * --
   */
  deleteMenuFile: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_MENU_FILE, {
        menu_file_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
